import { http } from './config'

export default {

  verificasabor:(cd) => {
    
    //return http.get('adicionais_selecao.php?cd_prod='+cd+'&ordem='+ord)
    return http.get('sabor.php?cd_prod='+cd)
  }
}